import {
  LastCompletedVisitFilterValue,
  VisitCountFilterValue,
} from './_types';
import {
  isLastCompletedVisitFilterComplete,
  isVisitCountFilterComplete,
} from './visitFilterValidation';

/** Payload sent to Rails */
export interface VisitCountFilterApiPayload {
  operator: VisitCountFilterValue['operator'];
  value: number;
  timeframeDays: number;
  direction?: VisitCountFilterValue['direction'];
}

export interface LastCompletedVisitFilterApiPayload {
  operator: LastCompletedVisitFilterValue['operator'];
  timeframeDays: number;
}

export const serializeVisitCountFilter = (
  value: VisitCountFilterValue | null | undefined,
  allowedTimeframeDays: readonly number[]
): VisitCountFilterApiPayload | undefined => {
  if (!isVisitCountFilterComplete(value, allowedTimeframeDays) || !value) {
    return undefined;
  }

  return {
    operator: value.operator,
    value: value.value as number,
    timeframeDays: value.timeframeDays as number,
    ...(value.direction && { direction: value.direction }),
  };
};

export const serializeLastCompletedVisitFilter = (
  value: LastCompletedVisitFilterValue | null | undefined,
  allowedTimeframeDays: readonly number[]
): LastCompletedVisitFilterApiPayload | undefined => {
  if (!isLastCompletedVisitFilterComplete(value, allowedTimeframeDays) || !value) {
    return undefined;
  }

  return {
    operator: value.operator,
    timeframeDays: value.timeframeDays as number,
  };
};
